import { render, staticRenderFns } from "./AssetReviewStepDependencies.vue?vue&type=template&id=8cefe2e8&"
import script from "./AssetReviewStepDependencies.vue?vue&type=script&lang=js&"
export * from "./AssetReviewStepDependencies.vue?vue&type=script&lang=js&"
import style0 from "./AssetReviewStepDependencies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cefe2e8')) {
      api.createRecord('8cefe2e8', component.options)
    } else {
      api.reload('8cefe2e8', component.options)
    }
    module.hot.accept("./AssetReviewStepDependencies.vue?vue&type=template&id=8cefe2e8&", function () {
      api.rerender('8cefe2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/AssetReview/ReviewSteps/AssetReviewStepDependencies.vue"
export default component.exports